import { EntityUpgrades, UnitType, UpgradeStatus, UpgradeType } from '../../../types/game-types';

export const upgrades: Partial<EntityUpgrades> = {
  shortSword: {
    id: UpgradeType.ShortSword,
    icon: ['sword0', 'plus1'],
    cost: { gold: 75 },
    costGrowthRate: 1.5,
    multiplier: 1,
    purchased: 0,
    bonusPerOwned: 0.05,
    purchaseLimit: 40,
    isUnlocked: false,
    type: UnitType.UPGRADE,
    tier: 'generators',
    status: UpgradeStatus.Unlocked,
  },
  longSword: {
    id: UpgradeType.LongSword,
    icon: ['sword1', 'plus2'],
    cost: { gold: 700 },
    costGrowthRate: 2,
    multiplier: 1,
    purchased: 0,
    bonusPerOwned: 0.1,
    purchaseLimit: 20,
    isUnlocked: false,
    type: UnitType.UPGRADE,
    tier: 'generators',
  },
  // twoHandedSword: {
  //   id: UpgradeType.TwoHandedSword,
  //   icon: ['sword2', 'plus3'],
  //   cost: { gold: 7000 },
  //   costGrowthRate: 1.8,
  //   multiplier: 1,
  //   purchased: 0,
  //   bonusPerOwned: 0.2,
  //   purchaseLimit: 10,
  //   isUnlocked: false,
  //   type: UnitType.UPGRADE,
  //   tier: 'generators',
  // },
  // criticalChance: {
  //   id: UpgradeType.CriticalChance,
  //   icon: ['sword5', 'random'],
  //   cost: { gold: 350 },
  //   costGrowthRate: 3,
  //   multiplier: 0,
  //   purchased: 0,
  //   purchaseLimit: 10,
  //   bonusPerOwned: 5,
  //   isUnlocked: false,
  //   type: UnitType.UPGRADE,
  //   tier: 'click',
  // },
  // criticalDamage: {
  //   id: UpgradeType.CriticalDamage,
  //   icon: ['bang2', 's_sword5'],
  //   cost: { gold: 1500 },
  //   costGrowthRate: 3,
  //   multiplier: 2,
  //   purchased: 0,
  //   purchaseLimit: 10,
  //   bonusPerOwned: 10,
  //   isUnlocked: false,
  //   type: UnitType.UPGRADE,
  //   tier: 'click',
  // },
  silverBlade: {
    id: UpgradeType.SilverBlade,
    icon: ['silverBar', 'sword1'],
    cost: { gold: 100 },
    costGrowthRate: 1.5,
    multiplier: 1,
    purchased: 0,
    bonusPerOwned: 0.1,
    purchaseLimit: 40,
    isUnlocked: false,
    type: UnitType.UPGRADE,
    tier: 'generators',
  },
  goldenBlade: {
    id: UpgradeType.GoldenBlade,
    icon: ['goldBar', 'sword1'],
    cost: { gold: 5000 },
    costGrowthRate: 2,
    multiplier: 1,
    purchased: 0,
    bonusPerOwned: 0.25,
    purchaseLimit: 40,
    isUnlocked: false,
    type: UnitType.UPGRADE,
    tier: 'generators',
  },
  battleShout: {
    id: UpgradeType.BattleShout,
    icon: ['s_units1', 'bang2'],
    cost: { gold: 9000 },
    costGrowthRate: 1.5,
    multiplier: 0,
    purchased: 0,
    bonusPerOwned: 0.001,
    purchaseLimit: 40,
    isUnlocked: false,
    type: UnitType.UPGRADE,
    tier: 'generators',
  },
  warCry: {
    id: UpgradeType.WarCry,
    icon: ['s_units3', 'h_bang5'],
    cost: { gold: 75000 },
    costGrowthRate: 2,
    multiplier: 0,
    purchased: 0,
    bonusPerOwned: 0.003,
    purchaseLimit: 40,
    isUnlocked: false,
    isLockedOnDemo: true,
    type: UnitType.UPGRADE,
    tier: 'generators',
  },
  loyalMercenaries: {
    id: UpgradeType.LoyalMercenaries,
    icon: ['units4', 'coin'],
    cost: { gold: 4000 },
    costGrowthRate: 2.9,
    multiplier: 0,
    purchased: 0,
    bonusPerOwned: 0.5,
    purchaseLimit: 20,
    isUnlocked: false,
    isLockedOnDemo: true,
    type: UnitType.UPGRADE,
    tier: 'generators',
  },
  // loyalServants: {
  //   id: UpgradeType.LoyalServants,
  //   icon: ['hearts2', 'u_l_units0'],
  //   cost: { gold: 4500 },
  //   costGrowthRate: 3.1,
  //   multiplier: 0,
  //   purchased: 0,
  //   bonusPerOwned: 10,
  //   purchaseLimit: 5,
  //   isUnlocked: false,
  //   type: UnitType.UPGRADE,
  //   tier: 'generators',
  // },
  teamWork: {
    id: UpgradeType.TeamWork,
    icon: ['sword0', 'h_sword1'],
    cost: { gold: 7000 },
    costGrowthRate: 6,
    multiplier: 0,
    purchased: 0,
    bonusPerOwned: 1,
    purchaseLimit: 5,
    isUnlocked: false,
    isLockedOnDemo: true,
    type: UnitType.UPGRADE,
    tier: 'generators',
  },
  barbarian: {
    id: UpgradeType.Barbarian,
    icon: ['axe4'],
    cost: { gold: 6000 },
    costGrowthRate: 3,
    multiplier: 0,
    purchased: 0,
    bonusPerOwned: 0.1,
    purchaseLimit: 80,
    isUnlocked: false,
    type: UnitType.UPGRADE,
    tier: 'generators',
  },
  thickArmor: {
    id: UpgradeType.ThickArmor,
    icon: ['armor2'],
    cost: { gold: 10000 },
    costGrowthRate: 3,
    multiplier: 1,
    purchased: 0,
    bonusPerOwned: 0.5,
    purchaseLimit: 20,
    isUnlocked: false,
    isLockedOnDemo: true,
    type: UnitType.UPGRADE,
    tier: 'generators',
  },
  fireArmor: {
    id: UpgradeType.FireArmor,
    icon: ['armor3'],
    cost: { gold: 30000 },
    costGrowthRate: 3,
    multiplier: 1,
    purchased: 0,
    bonusPerOwned: 0.5,
    purchaseLimit: 20,
    isUnlocked: false,
    isLockedOnDemo: true,
    type: UnitType.UPGRADE,
    tier: 'generators',
  },
};
